export default __webpack_public_path__ + "9a060eff973a9bdd497d0615a7e977c2.png";